<mat-dialog-content style="color: red">
    <h1>Error</h1>
    <p>{{ message }}</p>
</mat-dialog-content>

<mat-dialog-actions style="margin-bottom: 10px;">
    <button mat-raised-button [mat-dialog-close]="true" *ngFor="let customAction of customActions" (click)="customAction.actionCallback()">{{customAction.text}}</button>
</mat-dialog-actions>
